import Vue from "vue";
import axios from "axios";

const effConOrder = `/eff_contract/eff_con_orders`;
const personEffContractPath = `/eff_contract/person_eff_contracts`;

function setFormData(contract) {
    const formatData = new FormData();

    for  (let key in contract) {
        formatData.append(`person_eff_contract[${key}]`, contract[key]);
    }

    return formatData
}

const ApiService = {
    getEffConOrder() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`${effConOrder}/current_order.json`);
    },

    createEffConOrder(payloadOrder) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.post(`${effConOrder}.json`, {eff_con_order: payloadOrder});
    },

    async updateEffConOrder(payloadOrder, id) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.patch(`${effConOrder}/${id}.json`, {eff_con_order: payloadOrder});
    },

    sentPersonContractsToReview() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`${effConOrder}/sent_contract_review.json`);
    },

    resetPersonContractsToReview(id) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`${effConOrder}/reset_contract_review.json?id=${id}`);
    },


//-------------------------------------------------------------------------------------------------------------

    getPersonEffContracts() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`${personEffContractPath}.json`);
    },

    getPersonEffContract(id_contract) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`${personEffContractPath}/${id_contract}.json`);
    },

    createPersonEffContract(payloadOrder) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        const formData = setFormData(payloadOrder);

        return axios.post(`${personEffContractPath}.json`, formData,
            {headers: { 'Content-Type': 'multipart/form-data'}});
    },

    updatePersonEffContract(payloadOrder, id) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        const formData = setFormData(payloadOrder);

        return axios.patch(`${personEffContractPath}/${id}.json`, formData,
            {headers: { 'Content-Type': 'multipart/form-data'}});
    },

     deletePersonEffContract(id) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

        return axios.delete(`${personEffContractPath}/${id}.json`);
    },

    confirmContractPersonContract(id, statusContract) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.put(
          `${personEffContractPath}/${id}/confirm_contract_person_contract.json`,
          {person_eff_contract: {status: statusContract}}
        );
    },

    editFactContract(id, payload) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.put(`${personEffContractPath}/edit_contract_fact.json?id=${id}`, {person_eff_contract: payload});
    },

//--------------------------------------------------------------------------------------------------------

    getListEffContracts() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/get_contracts_part.json`);
    },

//-------------------------------------------------------------------------------------------------------

    getDataEmployee() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/get_data_person`);
    },

    getRoles() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/get_current_role`);
    },

    getTeacherList(ids=null, confirmed=null) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/get_teacher_list.json`, {params: {ids: ids, confirmed: confirmed}});
    },

    getEffContractsAll() {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/index_eff_contracts.json`);
    },

    getIndexContractsByPerson(id) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.get(`/index_contracts_by_person.json?id=${id}`);
    },

    filteredListPerson(names, confirmed) {
        const token = document.querySelector('[name=csrf-token]').content;
        axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
        return axios.post(`/filtered_persons.json`, {filter: {confirmed: confirmed, names: names}});
    },

    editOrdersWithUmuManager(ids, payload) {
        const token = document.querySelector('[name=csrf-token]').content;
        try {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            return axios.put(`${effConOrder}/edit_order_with_umu_manager.json`, {eff_con_order: payload}, {params: {ids: ids}});
        } catch (e) {
            return e
        }
    },

    resetEffConOrdersReview(ids) {
        const token = document.querySelector('[name=csrf-token]').content;
        try {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            return axios.get(`${effConOrder}/reset_eff_con_orders_review.json`,{params: {ids: ids}});
        } catch (e) {
            return e
        }
    },

    //------------------------------------------------AUTO_CALCULATE-------------------------------------------------------

    autoCalculateFacts() {
        const token = document.querySelector('[name=csrf-token]').content;
        try {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            return axios.post(`${personEffContractPath}/auto_calculate_facts.json`);
        } catch (e) {
            return e
        }
    },

}

export default ApiService;
